// Background removal cost scales with pixel count; phone photos are often
// 12MP+ and a phone-case sticker never needs that much detail, so shrink
// before it ever leaves the browser.
const MAX_UPLOAD_DIMENSION = 2048;

export async function resizeForUpload(file: File): Promise<File> {
    const bitmap = await createImageBitmap(file);
    const { width, height } = bitmap;

    if (width <= MAX_UPLOAD_DIMENSION && height <= MAX_UPLOAD_DIMENSION) {
        bitmap.close();
        return file;
    }

    const scale = MAX_UPLOAD_DIMENSION / Math.max(width, height);
    const newWidth = Math.round(width * scale);
    const newHeight = Math.round(height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = newWidth;
    canvas.height = newHeight;
    const ctx = canvas.getContext("2d");

    if (!ctx) {
        bitmap.close();
        return file;
    }

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(bitmap, 0, 0, newWidth, newHeight);
    bitmap.close();

    const blob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("Failed to resize image"))), "image/png");
    });

    return new File([blob], file.name.replace(/\.[^.]+$/, ".png"), { type: "image/png" });
}
